import { createLatLng, createNewOverlay } from "../google";

function Overlay(src, lat, lng, map) {
  this.img_ = null;
  this.imgSrc_ = src;
  this.latlng_ = createLatLng(lat, lng);
  this.angle_ = 0;
  this.setMap(map);
}

Overlay.prototype = createNewOverlay();

Overlay.prototype.onAdd = function() {
  const img = document.createElement('img');
  img.src = this.imgSrc_;
  img.style.borderStyle = 'none';
  img.style.borderWidth = '0px';
  img.style.position = 'absolute';
  this.img_ = img;
  const panes = this.getPanes();
  panes.overlayLayer.appendChild(img);
}

Overlay.prototype.setCoordinates = function(lat, lng) {
  this.latlng_ = createLatLng(lat, lng);
}

Overlay.prototype.setAngle = function(angle) {
  this.angle_ = angle;
}

Overlay.prototype.updatePosition = function() {
  const overlayProjection = this.getProjection();
  if (!overlayProjection) {
    return;
  }

  const location = overlayProjection.fromLatLngToDivPixel(this.latlng_);

  const img = this.img_;
  img.style.left = location.x - 25 + 'px';
  img.style.top = location.y - 25 + 'px';
  img.style.transform = `rotate(${this.angle_}deg)`;
  img.style.width = 50 + 'px';
  img.style.height = 50 + 'px';
  img.style.zIndex = 500;
}

Overlay.prototype.getCurrentLatLng = function() {
  return this.latlng_;
}

Overlay.prototype.draw = function() {
  this.updatePosition();
}

Overlay.prototype.onRemove = function() {
  this.img_.parentNode.removeChild(this.img_);
  this.img_ = null;
}

Overlay.prototype.removeFromMap = function() {
  this.setMap(null);
}

export const createOverlay = (iconURL, latitude, longitude, context) => new Overlay(iconURL, latitude, longitude, context);
